<div class="carousel slide" [ngStyle]="{'height': height}">
  @if (images.length > 1) {
    <ol class="carousel-indicators">
      @for (item of images; track item; let i = $index) {
        <li [class.active]="i === activeIndex" (click)="navigateTo(i)">
        </li>
      }
    </ol>
  }
  <div [ngStyle]="{'height': height}"  class="carousel-inner" role="listbox" style="display: flex; align-items: center;">
    <img style="vertical-align: middle; margin: auto;" [ngStyle]="{'max-height': height}" class="carousel-img" (click)="onImageClick.emit(img)" [src]="buildAttachmentUrl()" alt="{{(img && img.name) ? img.name : ''}} - Click to enlarge.">
    @if (images.length > 1) {
      <a style="opacity: .8;" class="left carousel-control" (click)="prev()">
        <span style="cursor: pointer;" class="glyphicon glyphicon-chevron-left"></span>
        <span class="sr-only">Previous</span>
      </a>
    }
    @if (images.length > 1) {
      <a style="opacity: .8;" class="right carousel-control" (click)="next()">
        <span style="cursor: pointer;" class="glyphicon glyphicon-chevron-right"></span>
        <span class="sr-only">Next</span>
      </a>
    }
  </div>

</div>
@if (img.description) {
  <div class="caption">
    {{img.description}}
  </div>
}
